const backgroundSize = {
  name: "background-size",
  path: "/background-size",
  title: "background-size",
  description: "Utilities for controlling an element's background size.",
  value: {
    "background-size": {
      "bg-auto": "auto",
      "bg-cover": "cover",
      "bg-contain": "contain",
      "bg-size-[<value>]": "<value>"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<div class="bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-auto h-32 w-64 border-2 border-color-gray-400 border-style-dashed"></div>
<div class="bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-cover h-32 w-64 border-2 border-color-gray-400 border-style-dashed"></div>
<div class="bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-contain h-32 w-64 border-2 border-color-gray-400 border-style-dashed"></div>
<div class="bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-size-[50%] h-32 w-64 border-2 border-color-gray-400 border-style-dashed"></div>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:bg-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">bg-auto</code>, <code>bg-cover</code>, and <code>bg-contain</code> utilities to control the background size of an element.
      </p>
      <div class="mx-auto max-w-lg grid grid-columns-1 gap-10">
        <div class="w-full">
          <p class="mb-2 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-auto</p>
          <div class="bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-auto h-64 w-full rounded-lg border-2 border-color-gray-400 border-style-dashed"></div>
        </div>
        <div class="w-full">
          <p class="mb-2 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-cover</p>
          <div class="bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-cover h-64 w-full rounded-lg border-2 border-color-gray-400 border-style-dashed"></div>
        </div>
        <div class="w-full">
          <p class="mb-2 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-contain</p>
          <div class="bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-contain h-64 w-full rounded-lg border-2 border-color-gray-400 border-style-dashed"></div>
        </div>
        <div class="w-full">
          <p class="mb-2 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-size-[<value>]</p>
          <div class="bg-no-repeat border bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-size-[50%] h-64 w-full rounded-lg border-2 border-color-gray-400 border-style-dashed"></div>
        </div>
      </div>
      `
    }
  ]
};

export default backgroundSize;
<div className="bg-size-[50%]"></div>